// components/ProductTable.tsx
import React from "react";
import { Order } from "src/shared/services/interfacev2";
import { roundValue } from "../../home/utils/formatters";

interface ProductTableProps {
  orderData: Order;
}

const ProductTable: React.FC<ProductTableProps> = ({ orderData }) => {
  const orderDetails = orderData.orderDetails ?? [];

  return (
    <div className="mb-4 text-sm">
      <div className="flex justify-between font-bold border-b border-black pb-1 mb-2">
        <div className="w-3/5">Description</div>
        <div className="w-1/5 text-center">Qty</div>
        <div className="w-1/5 text-right">Amount</div>
      </div>

      {orderDetails.map((detail, detailIndex) =>
        detail.products.map((product, productIndex) => (
          <div
            key={`${detailIndex}-${productIndex}`}
            className="flex justify-between mb-1"
          >
            <div className="w-3/5">{product.name}</div>
            <div className="w-1/5 text-center">{product.quantity}</div>
            <div className="w-1/5 text-right">
              {roundValue(product.lineTotal)}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProductTable;
